import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import TripsSubnavLayout from '../../pages/trip-matches';
import TripsAll from '../../pages/trip-matches/all';
import TripsSold from '../../pages/trip-matches/sold';
import TripMatch from '../../pages/trip-match';
import TripMatchDetails from '../../pages/trip-match/details';
import TripMatchDocs from '../../pages/trip-match/docs';
import TripDocumentsUpload from '../../pages/trip-match/document-upload/doc-upload-container';
import TripMatchMessages from '../../pages/trip-match/messages';
import TripMatchReviews from '../../pages/trip-match/reviews';
import TripMatchSales from '../../pages/trip-match/sales';
import SalesRecording from '../../pages/trip-match/sales-recording';

const useTripMatchesRoutes = () => (
  <>
    <Route path="trip-matches" element={<TripsSubnavLayout />}>
      <Route index element={<TripsAll />} handle={{ tab: '/' }} />
      <Route path="sold" element={<TripsSold />} handle={{ tab: '/sold' }} />
    </Route>
    <Route path="trip-matches/:tripMatchId" element={<TripMatch />}>
      <Route index element={<Navigate to="details" replace />} handle={{ tab: '/details' }} />
      <Route path="details" element={<TripMatchDetails />} handle={{ tab: '/details' }} />
      <Route path="messages" element={<TripMatchMessages />} handle={{ tab: '/messages' }} />
      <Route path="documents" element={<TripMatchDocs />} handle={{ tab: '/documents' }} />
      <Route path="documents/:documentType" element={<TripDocumentsUpload />} handle={{ tab: '/documents' }} />
      <Route path="reviews" element={<TripMatchReviews />} handle={{ tab: '/reviews' }} />
      <Route path="sales" element={<TripMatchSales />} handle={{ tab: '/sales' }} />
      <Route path="sales/:salesRecordingId" element={<SalesRecording />} handle={{ tab: '/sales' }} />
    </Route>
  </>
);

export default useTripMatchesRoutes;
